import { gql } from '@/__generated__/gql';

export const LIST_DUE_DILIGENCE_RECORD_QUERY = gql(`
  query DealRegistryPageListDueDiligenceRecords($data: DueDiligenceRecordsListDto!) {
    listDueDiligenceRecords(data: $data) {
      total
      limit
      offset
      records {
        id
        investment {
          id
          name
          assetClass
          managerId
          subAssetClasses
          securityStatus
          finalClose
          targetIRR
          targetYield
          tags
        }
        owner {
          id
          firstName
          lastName
          email
        }
        manager
        activeTier {
          id
          name
          order
          tasksCount
          funnel {
            id
            funnelStaticId
            name
            latestFunnel {
              name
              tiers {
                id
                name
                order
              }
            }
          }
        }
        activeTierOpenTasksCount
        approver {
          id
          firstName
          lastName
        }
        updatedAt
        createdAt
        activeTierOpenTasksCount
        status
        dealAssistantAIRuns {
          startedAt
          completedAt
        }
      }
    }
  }
`);

export const DELETE_DUE_DILIGENCE_RECORD_MUTATION = gql(`
  mutation DealRegistryPageDeleteDueDiligenceRecord($id: String!) {
    deleteDueDiligenceRecord(id: $id)
  }
`);

export const LIST_DUE_DILIGENCE_FUNNELS_DISTINCT_STATIC_ID_QUERY = gql(`
  query DealRegistryPageListDueDiligenceFunnelsDistinctStaticId {
    listDueDiligenceFunnelsDistinctStaticId {
      id
      funnelStaticId
      name
      createdAt
      status
      records {
        id
      }
    }
  }
`);
